import { useEffect, useRef } from 'preact/compat'
import { useDispatch, useSelector } from 'react-redux'
import { DataDog } from '../datadog'
import { cardinalCruiseUpdate, cardinalCruiseSelector } from '../redux/slice/cardinalCruiseSlice'

export default function useCardinalDDC() {
  const dispatch = useDispatch()
  const cardinalCruise = useSelector(cardinalCruiseSelector)
  const { isCardinalCollectingData } = cardinalCruise
  const cardinalDDCTimeout = 10000
  const timer = useRef(null)
  const callback = useRef(null)

  const cleanup = () => {
    clearTimeout(timer.current)
    timer.current = null
    // eslint-disable-next-line no-use-before-define
    window.removeEventListener('message', handleCardinalMessage, false)
  }
  const onTimeoutStart = () => {
    cleanup()
    timer.current = setTimeout(() => {
      dispatch(
        cardinalCruiseUpdate({
          isCardinalCollectingData: false,
        }),
      )

      callback.current()

      DataDog.warn(
        "Cardinal DDC wasn't collected because of timeout of 10 seconds",
      )
      cleanup()
    }, cardinalDDCTimeout)
  }

  function handleCardinalMessage(event) {
    if (!timer.current) return

    if (event.origin.includes('cardinalcommerce.com')) {
      const data = JSON.parse(event.data)

      if (data?.MessageType === 'profile.completed') {
        callback.current()

        cleanup()

        dispatch(
          cardinalCruiseUpdate({
            isCardinalCollectingData: false,
          }),
        )

        DataDog.info(`Cardinal DDC was collected with Status ${data?.Status}`)
      }
    }
  }

  useEffect(() => {
    if (isCardinalCollectingData) {
      window.addEventListener('message', handleCardinalMessage, false)
    } else {
      window.removeEventListener('message', handleCardinalMessage, false)
    }
  }, [isCardinalCollectingData])

  useEffect(
    () => () => {
      cleanup()
    },
    [],
  )

  return cb => {
    callback.current = cb
    dispatch(
      cardinalCruiseUpdate({
        isCardinalCollectingData: true,
      }),
    )

    onTimeoutStart()
  }
}
